import { render } from "./ChoiceItem.vue?vue&type=template&id=6062aee7&scoped=true"
import script from "./ChoiceItem.vue?vue&type=script&lang=js"
export * from "./ChoiceItem.vue?vue&type=script&lang=js"

import "./ChoiceItem.vue?vue&type=style&index=0&id=6062aee7&lang=scss&scoped=true"

import exportComponent from "/home/jeim2750/develop.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6062aee7"]])

export default __exports__